import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

export interface SetModuleRatingDialogState {
	coacheeId: string;
	moduleId: string;
}

@Injectable()
export class SetModuleRatingDialogStore extends Store<SetModuleRatingDialogState> {
	constructor() {
		super({}, { name: `ui-set-module-comment-dialog-${guid()}` });
	}
}
